import React from 'react';
import PropTypes from 'prop-types';

import messages from './messages';
import Form from '../../../../components/Form';

import '../styles.css';

const CreditCap = ({ onChange, initialValue, formatMessage }) => (
  <div
    styleName="transfer-website-container"
    data-cy="Premium-Hem-Transfer-Credit-Cap-Container"
  >
    <p>{formatMessage(messages.creditCapLabel)}</p>
    <Form.Input
      fluid
      min="0"
      type="number"
      value={initialValue.value}
      onChange={(e, { value }) => {
        onChange(e, { value });
      }}
      data-cy="Premium-Hem-Transfer-Credit-Cap-InputField"
    />
  </div>
);

CreditCap.propTypes = {
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
  initialValue: PropTypes.object,
};
export default CreditCap;
